export default "__VITE_ASSET__BHCHT0mn__"